import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@stockline/ui/components/toast";
import { useToast } from "@/hooks/use-toast";
import { useIsMobile } from "@/hooks/use-mobile";
import { usesMobileApp } from "@/lib/mobile-app";

export function Toaster() {
  const { toasts } = useToast();
  // usesMobileApp() covers the Capacitor build even on wide (tablet) viewports.
  const isMobile = useIsMobile() || usesMobileApp();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      {/* Pin to the TOP on mobile (bottom-auto kills the base bottom-0): the
          chat composer + bottom nav own the bottom edge, a bottom toast would
          cover the text input. */}
      <ToastViewport className={isMobile ? "bottom-auto left-0 top-0" : ""} />
    </ToastProvider>
  );
}
